export enum PlayerTabTypes {
  Radio = "radio",
  Podcast = "Podcast",
}
